import { Box, Card, Container, Grid, Stack, Typography, useTheme } from '@mui/material';
import { useSettingsContext } from 'src/components/settings';
import { useResponsive } from 'src/hooks/use-responsive';
import { useLocales } from 'src/locales';
import background from '../../assets/images/ecosystem_background.png';

function HomeEcosystem() {
  const theme = useTheme();

  const { t } = useLocales();
  const settings = useSettingsContext();
  const isDarkMode = settings.themeMode === 'dark';

  const mdUp = useResponsive('up', 'md');
  const smDown = useResponsive('down', 'sm');

  const renderMobile = (
    <Stack spacing={3} pb={10}>
      {/*  */}
      <Grid container justifyContent="center" spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Stack component={Card} px={2} pb={3} pt={0.5} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
            <Box
              component="img"
              src={`./assets/images/home/ecosystem/${isDarkMode ? 'SNEAKER' : 'SNEAKER_BLACK'}.png`}
              sx={{ width: 50, height: 50 }}
            />
            <Typography variant="h5" fontWeight="400">
              {t('walkup_lang_017')}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
            <Box
              component="img"
              src={`./assets/images/home/ecosystem/${isDarkMode ? 'GAMEPAD' : 'GAMEPAD_BLACK'}.png`}
              sx={{ width: 35, height: 35, mb: 1 }}
            />
            <Typography variant="h5" fontWeight="400">
              {t('walkup_lang_023')}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
            <Box
              component="img"
              src={`./assets/images/home/ecosystem/${isDarkMode ? 'SHOPPING_BAG' : 'SHOPPING_BAG_BLACK'}.png`}
              sx={{ width: 35, height: 35, mb: 1 }}
            />
            <Typography variant="h5" fontWeight="400">
              {t('walkup_lang_020')}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack component={Card} px={2} pb={3} pt={2} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
            <Box component="img" src={`./assets/images/home/ecosystem/${isDarkMode ? 'BONGA' : 'BONGA_BLACK'}.png`} sx={{ height: 15, mb: 1 }} />
            <Typography variant="h5" fontWeight="400">
              {t('walkup_lang_018')}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
            <Box
              component="img"
              src={`./assets/images/home/ecosystem/${isDarkMode ? 'CARD' : 'CARD_BLACK'}.png`}
              sx={{ width: 35, height: 35, mb: 1 }}
            />
            <Typography variant="h5" fontWeight="400" textAlign="center">
              {t('walkup_lang_019')}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
            <Box
              component="img"
              src={`./assets/images/home/ecosystem/${isDarkMode ? 'USERS' : 'USERS_BLACK'}.png`}
              sx={{ width: 35, height: 35, mb: 1 }}
            />
            <Typography variant="h5" fontWeight="400">
              {t('walkup_lang_021')}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
            <Box
              component="img"
              src={`./assets/images/home/ecosystem/${isDarkMode ? 'WALLET' : 'WALLET_BLACK'}.png`}
              sx={{ width: 35, height: 35, mb: 1 }}
            />
            <Typography variant="h5" fontWeight="400">
              {t('walkup_lang_066')}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
            <Box
              component="img"
              src={`./assets/images/home/ecosystem/${isDarkMode ? 'ROBOT' : 'ROBOT_BLACK'}.png`}
              sx={{ width: 35, height: 35, mb: 1 }}
            />
            <Typography variant="h5" fontWeight="400">
              {t('walkup_lang_016')}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );

  return (
    <Container maxWidth="lg">
      <Stack sx={{ py: { xs: 5, md: 10 } }}>
        <Typography variant="h2" color="primary" align="center" mb={5} textTransform="uppercase">
          {t('walkup_lang_015')}
        </Typography>

        {smDown && renderMobile}

        {!smDown && (
          <Stack
            spacing={3}
            pb={10}
            sx={{
              ...(mdUp && {
                backgroundImage: `url(${background})`,
                backgroundPosition: 'top',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '600px ',
              }),
            }}
          >
            {/*  */}
            <Grid container justifyContent="center" spacing={3}>
              <Grid item xs={12} sm={6} md={3}>
                <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
                  <Box
                    component="img"
                    src={`./assets/images/home/ecosystem/${isDarkMode ? 'GAMEPAD' : 'GAMEPAD_BLACK'}.png`}
                    sx={{ width: 35, height: 35, mb: 1 }}
                  />
                  <Typography>{t('walkup_lang_023')}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Stack component={Card} px={2} pb={3} pt={0.5} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
                  <Box
                    component="img"
                    src={`./assets/images/home/ecosystem/${isDarkMode ? 'SNEAKER' : 'SNEAKER_BLACK'}.png`}
                    sx={{ width: 50, height: 50 }}
                  />
                  <Typography>{t('walkup_lang_017')}</Typography>
                </Stack>
              </Grid>
            </Grid>

            <Grid container spacing={3} justifyContent="space-between">
              {/*  */}
              <Grid item xs={12} sm={6} md={3}>
                <Grid container justifyContent="center" spacing={3}>
                  <Grid item xs={12}>
                    <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
                      <Box
                        component="img"
                        src={`./assets/images/home/ecosystem/${isDarkMode ? 'SHOPPING_BAG' : 'SHOPPING_BAG_BLACK'}.png`}
                        sx={{ width: 35, height: 35, mb: 1 }}
                      />
                      <Typography>{t('walkup_lang_020')}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
                      <Box
                        component="img"
                        src={`./assets/images/home/ecosystem/${isDarkMode ? 'CARD' : 'CARD_BLACK'}.png`}
                        sx={{ width: 35, height: 35, mb: 1 }}
                      />
                      <Typography textAlign="center">{t('walkup_lang_019')}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
                      <Box
                        component="img"
                        src={`./assets/images/home/ecosystem/${isDarkMode ? 'WALLET' : 'WALLET_BLACK'}.png`}
                        sx={{ width: 35, height: 35, mb: 1 }}
                      />
                      <Typography>{t('walkup_lang_066')}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>

              {/*  */}

              <Grid item xs={12} sm={6} md={3}>
                <Grid container justifyContent="center" spacing={3}>
                  <Grid item xs={12}>
                    <Stack component={Card} px={2} pb={3} pt={2} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
                      <Box
                        component="img"
                        src={`./assets/images/home/ecosystem/${isDarkMode ? 'BONGA' : 'BONGA_BLACK'}.png`}
                        sx={{ height: 15, mb: 1 }}
                      />
                      <Typography>{t('walkup_lang_018')}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
                      <Box
                        component="img"
                        src={`./assets/images/home/ecosystem/${isDarkMode ? 'USERS' : 'USERS_BLACK'}.png`}
                        sx={{ width: 35, height: 35, mb: 1 }}
                      />
                      <Typography>{t('walkup_lang_021')}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack component={Card} px={2} pb={3} pt={1} alignItems="center" sx={{ borderTop: `3px solid ${theme.palette.primary.main}` }}>
                      <Box
                        component="img"
                        src={`./assets/images/home/ecosystem/${isDarkMode ? 'ROBOT' : 'ROBOT_BLACK'}.png`}
                        sx={{ width: 35, height: 35, mb: 1 }}
                      />
                      <Typography>{t('walkup_lang_016')}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Stack>
        )}
      </Stack>
    </Container>
  );
}

export default HomeEcosystem;
